import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import Heritage from "./sections/Heritage";
import Story from "./sections/Story";
import Mission from "./sections/Mission";
import TheMissYvonneLegacy from "./sections/TheMissYvonneLegacy";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <Heritage />
      <Story />
      <Mission />
      <TheMissYvonneLegacy />
      <Footer />
    </div>;
}